import { createSlice, configureStore } from '@reduxjs/toolkit';

const initialState = {
    seriesData: {},
    style: "Bend",
    size: "18x18",
    productSelection: [],
    activeProfile: null,
    roomscene: "Mannington\\Images\\Standard\\Airport_3502",
    currentView: "swatch", // 'swatch' or 'room'
    currentImageUrl: null,
    chosenPattern: null, // Selected pattern from the Rug tab pattern menu
    hiddenColors: [], // Array of color IDs that are hidden in CustomizeColors
    patternColors: [], // Array of color objects for the current pattern
    displayColors: [], // Sorted/deduped colors for display (computed from patternColors)
    selectedColorIndex: null, // Index of the currently selected color in CustomizeColors
    selectedRoomscene: null, // Selected room scene from RoomscenesPopup
    selectedFloorProduct: null, // Selected floor product from Floor tab
    menuActiveSection: 'customize', // Active section in ProductMenu: 'pattern', 'customize', 'rug-shape-size'
    menuActiveTab: 'rug' // Active tab in ProductMenu: 'rug' or 'floor'
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setSeriesData(state, action){
            state.seriesData[action.payload.seriesId] = action.payload.data;
        },
        setStyle(state, action) {
            state.style = action.payload;
        },
        setSize(state, action) {
            state.size = action.payload;
        },
        setProductSelection(state, action) {
            state.productSelection = action.payload;
        },
        addProduct(state, action) {
            state.productSelection.push(action.payload);
        },
        removeProduct(state, action) {
            state.productSelection = state.productSelection.filter(id => id !== action.payload);
        },
        clearProductSelection(state) {
            state.productSelection = [];
        },
        setActiveProfile(state, action) {
            state.activeProfile = action.payload;
        },
        clearActiveProfile(state) {
            state.activeProfile = null;
        },
        setRoomscene(state, action) {
            state.roomscene = action.payload;
        },
        setCurrentView(state, action) {
            state.currentView = action.payload;
        },
        setCurrentImageUrl(state, action) {
            state.currentImageUrl = action.payload;
        },
        setChosenPattern(state, action) {
            state.chosenPattern = action.payload;
            state.hiddenColors = []; // Reset hidden colors when pattern changes
            state.patternColors = []; // Reset pattern colors when pattern changes
            state.displayColors = []; // Reset display colors when pattern changes
            state.selectedColorIndex = null; // Reset selected color index
        },
        clearChosenPattern(state) {
            state.chosenPattern = null;
            state.hiddenColors = [];
            state.patternColors = [];
            state.displayColors = [];
            state.selectedColorIndex = null;
        },
        toggleHiddenColor(state, action) {
            const colorId = action.payload;
            const index = state.hiddenColors.indexOf(colorId);
            if (index === -1) {
                state.hiddenColors.push(colorId);
            } else {
                state.hiddenColors.splice(index, 1);
            }
        },
        clearHiddenColors(state) {
            state.hiddenColors = [];
        },
        setPatternColors(state, action) {
            state.patternColors = action.payload;
        },
        setDisplayColors(state, action) {
            state.displayColors = action.payload;
        },
        setSelectedColorIndex(state, action) {
            state.selectedColorIndex = action.payload;
        },
        updatePatternColor(state, action) {
            const { originalId, newProduct } = action.payload;
            // Update all colors that match the original ID
            state.patternColors = state.patternColors.map(color => {
                if (color.originalId === originalId) {
                    return {
                        ...color,
                        product: newProduct,
                        currentId: newProduct.id,
                        sku: newProduct.sku || color.sku
                    };
                }
                return color;
            });
        },
        setSelectedRoomscene(state, action) {
            state.selectedRoomscene = action.payload;
        },
        setSelectedFloorProduct(state, action) {
            state.selectedFloorProduct = action.payload;
        },
        setMenuActiveSection(state, action) {
            state.menuActiveSection = action.payload;
        },
        setMenuActiveTab(state, action) {
            state.menuActiveTab = action.payload;
        }
    }
});

const store = configureStore({
    reducer: {
        app: appSlice.reducer
    }
});

export const appActions = appSlice.actions;
export default store;
